import React from "react";

const Dashboard = () => {
  return (
    <div className="dashboard">
      <div className="dashcard">
        <div className="card">
          <h2>Todays Sells</h2>
          <p>23</p>
        </div>

        <div className="card">
          <h2>Order Count</h2>
          <p>23</p>
        </div>
        <div className="card">
          <h2>Total amount</h2>
          <p>23</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
